import React from 'react';
import type { LscVodCandidate } from '../types';
import { getVodReviewProgressSteps, type VodReviewStepStatus } from '../vodTruth';

interface VodReviewProgressProps {
  candidate: LscVodCandidate;
  suggestions?: Array<{ id?: string }>;
  className?: string;
}

const STATUS_STYLES: Record<VodReviewStepStatus, string> = {
  complete: 'border-green-700/60 bg-green-900/20 text-green-200',
  current: 'border-primary-600 bg-primary-900/30 text-primary-100 ring-1 ring-primary-600/40',
  blocked: 'border-red-800/60 bg-red-900/20 text-red-200',
  optional: 'border-secondary-600 bg-secondary-800/40 text-secondary-400',
  not_started: 'border-secondary-700 bg-secondary-900/40 text-secondary-500',
};

const STATUS_LABELS: Record<VodReviewStepStatus, string> = {
  complete: 'Complete',
  current: 'Current',
  blocked: 'Blocked',
  optional: 'Optional',
  not_started: 'Not started',
};

const VodReviewProgress: React.FC<VodReviewProgressProps> = ({
  candidate,
  suggestions = [],
  className = '',
}) => {
  const steps = getVodReviewProgressSteps(candidate, suggestions);

  return (
    <section
      className={`card ${className}`.trim()}
      data-testid="vod-review-progress"
      aria-label="Review progress"
    >
      <h2 className="text-lg font-semibold text-white mb-4">Review progress</h2>
      <ol className="grid gap-3 sm:grid-cols-2 lg:grid-cols-5">
        {steps.map((step, index) => (
          <li
            key={step.key}
            className={`rounded-lg border px-3 py-3 text-sm ${STATUS_STYLES[step.status]}`}
            data-testid={`vod-review-step-${step.key}`}
            data-step-status={step.status}
          >
            <p className="text-xs uppercase tracking-wide opacity-80 mb-1">
              Step {index + 1}
            </p>
            <p className="font-medium">{step.label}</p>
            <p className="text-xs mt-1 opacity-90">
              {step.description ?? STATUS_LABELS[step.status]}
            </p>
          </li>
        ))}
      </ol>
    </section>
  );
};

export default VodReviewProgress;
